import { Component, Input } from '@angular/core';
import { DatiPignoramento } from 'src/app/common/models/dati-pignoramento/dati-pignoramento';

@Component({
    selector: '[dati_pignoramento_entity_view]',
  templateUrl: 'dati-pignoramento-entity-view.component.html',
})

export class DatiPignoramentoEntityViewComponent {
  @Input()
  element: DatiPignoramento;
}
